import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import React from 'react'
import { string } from 'yup'

import { useAppSelector, useAppDispatch } from 'redux/Hook'
import { setAnswer } from 'redux/slices/SignupFormAnswers'
import { getErrorHelperText } from 'lib/participantProfile/Helper'

export const validateRadioButtonQuestion = async (
  answer: { id: string },
  question: QuestionsItems,
): Promise<string[]> => {
  let schema = string().nullable()
  if (question.required) {
    schema = schema.required()
  }

  try {
    await schema.validate(answer?.id)
    return []
  } catch (err: any) {
    return err.errors
  }
}

const RadioButtonQuestion = ({
  question,
  id,
  options,
  readOnlyMode,
  required,
  inLineOptions,
}: RadioButtonQuestionProps) => {
  const { answers, errors } = useAppSelector((state) => state.signupAnswers)
  const error = errors[id] || []
  const dispatch = useAppDispatch()
  const answer = answers[id]?.id || null

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!readOnlyMode) {
      const answer = (event.target as HTMLInputElement).value
      dispatch(setAnswer({ questionId: id, answer: { id: answer } }))
    }
  }

  return (
    <Box key={id}>
      <FormControl
        required={required}
        variant="standard"
        fullWidth
        error={error.length > 0}
      >
        <FormLabel> {question} </FormLabel>

        <RadioGroup
          aria-labelledby="radio-button-question"
          name="radio-button-question-group"
          value={answer}
          aria-required={required}
          onChange={handleChange}
          row={inLineOptions}
        >
          {options.map((option: SignupFormQuestionOptions) => {
            return (
              <FormControlLabel
                key={option.id}
                value={option.id}
                control={<Radio required={required} />}
                label={option.name}
              />
            )
          })}
        </RadioGroup>
        <FormHelperText>{getErrorHelperText(error, question)}</FormHelperText>
      </FormControl>
    </Box>
  )
}

export default RadioButtonQuestion
